import {
    CREATEANNOUNCEMENT_SUCCESS,
    CREATEANNOUNCEMENT_FAIL,
    GETANNOUNCEMENT_SUCCESS,
    GETANNOUNCEMENT_FAIL,
    GETANNOUNCEMENTITEM_SUCCESS,
    GETANNOUNCEMENTITEM_FAIL,
    EDITANNOUNCEMENT_SUCCESS,
    EDITANNOUNCEMENT_FAIL,
    DELETEANNOUNCEMENT_SUCCESS,
    DELETEANNOUNCEMENT_FAIL,
    GETANNOUNCEMENTCURRENTITEM_SUCCESS,
    GETANNOUNCEMENTCURRENTITEM_FAIL
} from "./types";



import AnnouncementService from "../services/announcement.service"


export const getAnnouncement = (data)=> async(dispatch)=>{
        
    try{
        const res = await AnnouncementService.getAnnouncement(data);
        
        dispatch({
          type: GETANNOUNCEMENT_SUCCESS,
          list: res,
        });
        
        return res
    }catch (error){
        
        dispatch({
            type: GETANNOUNCEMENT_FAIL,
            list: {error: error.response},
          });
          const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          return error.response
    }
}


export const editAnnouncement= (form)=>(dispatch)=>{
      
    return AnnouncementService.editAnnouncement(form).then(
        (response)=>{
              
            dispatch({
                type:EDITANNOUNCEMENT_SUCCESS,
                item:response
            });
            
            return response

        },
        (error)=>{
            dispatch({
                type: EDITANNOUNCEMENT_FAIL,
              });
            console.log(error);
              return Promise.reject();
        }
    );
}



export const deleteAnnouncement= (data)=>(dispatch)=>{
      
    return AnnouncementService.deleteAnnouncement(data).then(
        (response)=>{
            dispatch({
                type:DELETEANNOUNCEMENT_SUCCESS,
            });
              
        },
        (error)=>{
            dispatch({
                type: DELETEANNOUNCEMENT_FAIL,
              });
            console.log(error);
                 
              return Promise.reject();
        }
    );
}

export const getAnnouncementItem = (data)=>(dispatch)=>{
    return AnnouncementService.getAnnouncementItem(data).then(
        (response)=>{
              
            dispatch({
                type:GETANNOUNCEMENTITEM_SUCCESS,
                item:response,
            });
              
            return response

        },
        (error)=>{
            dispatch({
                type: GETANNOUNCEMENTITEM_FAIL,
              });
            console.log(error);
                 
              return Promise.reject();
        }
    );

}


export const getAnnouncementCurrentItem = (data)=>(dispatch)=>{
    return AnnouncementService.getAnnouncementItem(data).then(
        (response)=>{
              
            dispatch({
                type:GETANNOUNCEMENTCURRENTITEM_SUCCESS,
                item:response,
            });
              
            return response

        },
        (error)=>{
            dispatch({
                type: GETANNOUNCEMENTCURRENTITEM_FAIL,
              });
            console.log(error);
                 
              return Promise.reject();
        }
    );

}


export const addAnnouncement = (data)=> async(dispatch)=>{
    try {
        const res = await AnnouncementService.addAnnouncement(data);
        dispatch({
          type: CREATEANNOUNCEMENT_SUCCESS,
          item: res
        });
        return res
    }catch (error){
        dispatch({
            type: CREATEANNOUNCEMENT_FAIL,
            item: {error: error.response},
          });
          const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          return error.response;
    }
}